module.exports = __webpack_public_path__ + "img/search.e6658d3f.svg";